import { render, staticRenderFns } from "./SuperAdminFirmware.vue?vue&type=template&id=3b3d3d96"
import script from "./SuperAdminFirmware.vue?vue&type=script&lang=js"
export * from "./SuperAdminFirmware.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports